<template>
  <el-dialog :title="title" :visible.sync="visible" :close-on-click-modal="false" width="460px" @open="openSessionHandler" @closed="$emit('closed')">
    <div class="filepath-ctn">
      <filepath :fullPath="sessDir" prefix="目录:" />
    </div>

    <input-session ref="inputSess" :title="title" :sess="sess" :focusID="focusID" :sessDir="sessDir" :validateFileExist="true" @updateSession="updateSession" @ok="okHandler" />
    <span slot="footer" class="dialog-footer">
      <el-button @click="hide" size="mini">取 消</el-button>
      <el-button v-show="posting" type="primary" size="mini"><i class="el-icon-loading" /></el-button>
      <el-button v-show="! posting" type="primary" @click="okHandler" size="mini">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import filepath from "../common/filepath"
import InputSession from "./inputSession"

export default {
  name: "newSession",
  components: {InputSession, filepath},
  props: {
    sessDir: String,
  },
  data() {
    return {
      visible: false,
      title: "新建会话",
      sess: new this.model.Session(),
      posting: false,
      focusID: this.utils.uuid(),
    }
  },
  computed: {
    sessFilePath: function() {
      return `${this.sessDir}/${this.sess.Name}`
    },
  },
  mounted() {
    console.debug("mounted sessDir:", this.sessDir)
    let self = this
    self.sess.Protocol = "ssh"
    self.sess.Port = 22
    self.sess.AuthType = "password"
  },
  methods: {
    show() {this.visible = true},
    hide() {this.visible = false},
    openSessionHandler: function() {
      this.utils.domFocusById(this.focusID)
      this.$refs.inputSess ? this.$refs.inputSess.updateKeys() : console.log("skip update inputSess keys cause inputSess is undefined")
    },
    updateSession(s) {
      this.sess = s
    },
    okHandler() {
      console.log("new session ok handler")
      // this.$refs.inputSess.validateAll()
      // 检查输入内容是否有效
      if (! this.$refs.inputSess.isInputValid()) {
          this.$message.error("新建会话参数错误")
          return
      }
      this.api.postNewSession(this, this.sess, this.sessFilePath, this.sessExistHandler, this.successHandler)
    },
    sessExistHandler() {
      this.$message.error("会话已存在")
    },
    successHandler() {
      this.visible = false
      this.env.showSessionList({refresh: true})
    },

  },
}
</script>

<style scoped>
.filepath-ctn {
  padding: 0 6px;
}
</style>
